import styled from 'styled-components';
import { colourPalette } from 'styles/styles';

export const DetailsPanelContentConditionsListStyle = {
  Container: styled.div`
    margin-top: 16px;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid ${colourPalette.neutral300};
  `,
  Title: styled.p`
    margin: 0;
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
    color: ${colourPalette.neutral500};
    text-transform: uppercase;
    margin-bottom: 16px;
  `,
};
